// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"23b09d38","20":"f76d7ed4","37":"cdf9f94e","196":"ea562901","552":"12cf82c6","891":"372198f9"}[chunkId] + ".css";
};